<template>
  <div class="map-large"></div>
</template>

<script>
import gmapsInit from "@/utils/gmaps";

export default {
  computed: {
    location() {
      let value = false;
      if (this.map) {
        this.map.setCenter({
          lat: this.$store.state.ui.latitude,
          lng: this.$store.state.ui.longitude
        });
        value = true;
      }
      return value;
    },
    homePosition() {
      return this.$store.state.ui.homePosition;
    },
    appAsset() {
      return this.homePosition ? this.homePosition.gemeente.app_asset : null;
    }
  },
  watch: {
    homePosition: function(val) {
      this.setMapPosition(val);
    }
  },
  async mounted() {
    try {
      let self = this;
      gmapsInit().then(function(google) {
        var map = new google.maps.Map(self.$el, {
          disableDefaultUI: true,
          draggable: false,
          draggableCursor: "auto"
        });

        self.google = google;
        self.map = map;
        var initPosition;

        if (self.homePosition) {
          initPosition = {
            lat: self.homePosition.latitude,
            lng: self.homePosition.longitude
          };
        } else {
          initPosition = { lat: 52, lng: 5 };
        }

        map.setZoom(7);
        map.setCenter(initPosition);

        var marker = new google.maps.Marker({
          map: map,
          position: initPosition,
          opacity: 0,
          icon: {
            url: "/ic_location@2x.png",
            anchor: new google.maps.Point(16, 16),
            scaledSize: new google.maps.Size(32, 32)
          }
        });

        var circle = new google.maps.Circle({
          opacity: 0,
          map: map,
          strokeWeight: 0,
          fillColor: self.appAsset ? self.appAsset.color_primary : "#6DCC00",
          fillOpacity: 0,
          center: initPosition,
          radius: self.homePosition ? self.homePosition.radius : 500
        });

        if (self.homePosition) {
          map.fitBounds(circle.getBounds(), 0);
        }

        if (self.homePosition) {
          marker.setOpacity(1);
          circle.setOptions({ fillOpacity: 0.33 });
        }

        self.marker = marker;
        self.circle = circle;
      });
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    setMapPosition(position) {
      if (position) {
        var latlong = { lat: position.latitude, lng: position.longitude };

        this.map.setCenter(latlong);

        this.marker.setPosition(latlong);
        this.marker.setOpacity(1);
        this.circle.setCenter(latlong);
        this.circle.setRadius(position.radius);
        this.circle.setOptions({
          fillOpacity: 0.33,
          fillColor: this.appAsset ? this.appAsset.color_primary : "#6DCC00"
        });
        this.map.fitBounds(this.circle.getBounds(), 0);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.map-large {
  flex: 1;
  width: 100%;
}
</style>
